import type { InvestmentPack, PackBenefit, Project } from "../types/api";

/** Libellés multilingues stockés côté API (FR source + EN/DE/PT). */
export function pickProjectName(project: Project, lang: string): string {
  if (lang.startsWith("pt") && project.namePt) return project.namePt;
  if (lang.startsWith("de") && project.nameDe) return project.nameDe;
  if (lang.startsWith("en") && project.nameEn) return project.nameEn;
  return project.name;
}

export function pickProjectDescription(project: Project, lang: string): string {
  if (lang.startsWith("pt") && project.descriptionPt) return project.descriptionPt;
  if (lang.startsWith("de") && project.descriptionDe) return project.descriptionDe;
  if (lang.startsWith("en") && project.descriptionEn) return project.descriptionEn;
  return project.description;
}

export function pickPackName(pack: InvestmentPack, lang: string): string {
  if (lang.startsWith("pt") && pack.namePt) return pack.namePt;
  if (lang.startsWith("de") && pack.nameDe) return pack.nameDe;
  if (lang.startsWith("en") && pack.nameEn) return pack.nameEn;
  return pack.name;
}

export function pickPackDescription(
  pack: InvestmentPack,
  lang: string
): string | null {
  const desc = pack.description;
  if (lang.startsWith("pt") && pack.descriptionPt) return pack.descriptionPt;
  if (lang.startsWith("de") && pack.descriptionDe) return pack.descriptionDe;
  if (lang.startsWith("en") && pack.descriptionEn) return pack.descriptionEn;
  return desc;
}

export function pickBenefitText(benefit: PackBenefit, lang: string): string {
  if (lang.startsWith("pt") && benefit.benefitTextPt) return benefit.benefitTextPt;
  if (lang.startsWith("de") && benefit.benefitTextDe) return benefit.benefitTextDe;
  if (lang.startsWith("en") && benefit.benefitTextEn) return benefit.benefitTextEn;
  return benefit.benefitText;
}
